import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_FILES_DRIVER_RESET = 'POST_FILES_DRIVER_RESET';
export const POST_FILES_DRIVER_LOADING = 'POST_FILES_DRIVER_LOADING';
export const POST_FILES_DRIVER_SUCCESS = 'POST_FILES_DRIVER_SUCCESS';
export const POST_FILES_DRIVER_REJECT = 'POST_FILES_DRIVER_REJECT';

//* ACTIONS ------------------------------------------------
export const postFilesDriverReset = () => ({ type: POST_FILES_DRIVER_RESET });
export const postFilesDriverLoading = () => ({ type: POST_FILES_DRIVER_LOADING });
export const postFilesDriverSuccess = (payload) => ({ type: POST_FILES_DRIVER_SUCCESS, payload });
export const postFilesDriverReject = (payload) => ({ type: POST_FILES_DRIVER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postFilesDriverRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/Providers/web/AddProviderDriverUploadFile`, options);
};


